import React from "react";

const HealthCheck = (): React.ReactElement => {
  return <div>Brokerdash App is healthy</div>;
};

export default HealthCheck;
